import { object, string } from 'yup';

export const contactFormSchema = object({
    name: string().required('Name is a required field'),
    email: string().email().required('E-mail is a required field'),
    message: string().required('Message is a required field'),
});
